import React, { useState, useEffect } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/de';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Project } from '../../types/api';
import { projectsAPI } from '../../services/api';

moment.locale('de');
const localizer = momentLocalizer(moment);

export const ProjectCalendar: React.FC = () => {
  const [projects, setProjects] = useState<Project[]>([]);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const response = await projectsAPI.getProjects();
      setProjects(response);
    } catch (error) {
      console.error('Error fetching projects:', error);
    }
  };

  const events = projects.map(project => ({
    id: project.id,
    title: project.name,
    start: new Date(project.start_date),
    end: project.end_date ? new Date(project.end_date) : undefined,
    allDay: true,
  }));

  return (
    <div style={{ height: 600 }}>
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        style={{ height: '100%' }}
      />
    </div>
  );
}; 